module.exports = __webpack_public_path__ + "static/img/weather25.3edcf131.png";